export default __webpack_public_path__ + "static/media/MicrosoftTeams-image (1).19d23775.png";